import React, { useEffect, useState } from 'react'
import Header from './Header'
import Navbar from './Navbar'
import HeroSection from './HeroSection'
import { Link, useNavigate } from 'react-router-dom'
import Footer from './Footer'
import aos from 'aos'

const Careers = () => {
    const navigate = useNavigate();
    const [jobs, setJobs] = useState([]);   
    
    useEffect(() => {
        aos.init({
          duration: 1000,
          once: true,
        });
        window.scrollTo(0, 0);

        fetch('/api/all')
      .then(res => res.json())
      .then(data => {
        console.log(data);
        if (data.success) {
          setJobs(data.data);
        }
      })
      .catch(err => console.error('Error fetching job descriptions:', err));
      }, []);

  const handleViewJob = (job) => {
    navigate('/careers/jobdescription', { state: { jobData: job } });
  };

  return (
    <div className="app">
        <Header />
        <Navbar />
        <HeroSection 
        title="Careers" 
        breadcrumb={
          <>
            <Link to={"/careers"}>Careers</Link>             
          </>
        } 
      />

      <div className="max-w-7xl mx-auto p-12 sm:p-6 bg-lightBlue">
        <div>
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
                {jobs.map((card, index) => (
                    <CareerCard
                    key={index}
                    title={card.title}
                    description={card.description}
                    image={card.image}
                    altText={card.altText}
                    aosDelay={card.aosDelay}
                    onClick={() => handleViewJob(card)}
                    />
                ))}
                </div>
            </div>
        </div>
      </div>


      <Footer />
    </div>
  )
}

const CareerCard = ({ title, description, image, altText, aosDelay, onClick }) => {
    return (
      <div className="bg-white rounded-lg hover:shadow-lg transition-shadow overflow-hidden"
      data-aos="fade-up"
      data-aos-delay={aosDelay}>
        <div className="h-64 overflow-hidden">
          <img src={`https://kristellar.com/${image.replace(/\\/g, "/")}`} alt={altText} className="w-full h-full object-cover" />
        </div>
        <div className="p-6">
          <h2 className="text-2xl font-bold text-gray-700 mb-4">{title}</h2>
          <p className="text-gray-600 mb-6 text-md">{description}</p>
          <div className="flex justify-end">
            <button 
              onClick={onClick}
              className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
            >
              Read more
              <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 4.5L21 12M21 12L13.5 19.5M21 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    );
  };
  

export default Careers